import { useMemo } from "react";
import { useQuestionnaireActions } from "./useQuestionnaireActions";

/**
 * Show/hide question helpers. No state subscription.
 *
 * @example const { show, hide } = useQuestions();
 */
export function useQuestions() {
  const actions = useQuestionnaireActions();

  return useMemo(
    () => ({
      show: actions.setVisible,
      hide: actions.setHidden,
    }),
    [actions.setVisible, actions.setHidden],
  );
}
